import { createAction } from 'redux-actions';

export const startSendMessage = createAction('START_SEND_MESSAGE');

export const resolveSendMessage = createAction('RESOLVE_SEND_MESSAGE');

export const getMessages = createAction('GET_MESSAGES');

export const setMessages = createAction('SET_MESSAGES');

export const cleanMessages = createAction('CLEAN_MESSAGES');
